import { GET_DATA, GET_MENU, SEARCH_MENU, FILTER_ITEMS, SPL_CAT } from "../actionTypes";
import axios from './axios';
import _ from "lodash"

var url_string = window.location.href;
var url = new URL(url_string);


export const getData = () => async (dispatch, getState) => {
    const state = getState();
    if (state.restaurant.details) {
        return;
    }
    const res = await axios.post('merchant/get', {
        merchant_id: state.restaurant.merchant_id,
    });
    dispatch({
        type: GET_DATA,
        payload: res.data.details.data[0]
    })
}


export const getMenu = () => async (dispatch, getState) => {
    const state = getState();
    const token = state.user.token;
    const table = state.table.table;
    const res = await axios.post('menu/get', {
        merchant_id: state.restaurant.merchant_id,
        sub_category: 1,
        token: token,
        table_number: table
    });

    dispatch({
        type: GET_MENU,
        payload: res.data.details
    })

}

export const loadSpecialCategory = (cat_id, cat_name) => async (dispatch, getState) => {
    let { original_menu } = getState().restaurant;
    const state = getState();
    const token = state.user.token;
    const res = await axios.post('menu/getspecialcat', {
        merchant_id: state.restaurant.merchant_id,
        cat_id: cat_id,
        token: token
    });
    const specialCat = res.data.details.items;
    if (specialCat) {
        function filterItems1(category, search) {
            return category && category.items && category.items.filter(item => specialCat.indexOf(item.item_id) != -1);
        }

        function filterCategories1(category, search) {
            return category && category.items && category.items.some(item => specialCat.indexOf(item.item_id) != -1);
        }

        let splcategory = {};
        splcategory.cat_id = cat_id;
        splcategory.category_name = cat_name;
        splcategory.items = [];
        const newMenu = filterItemsAll(original_menu, filterCategories1, filterItems1);
        newMenu.forEach(category => {
            if (category.items) {
                category.items.forEach(item => {
                    const itemNew = { ...item };
                    const item_id = item.item_id;
                    itemNew.categoryNames = category.category_name;
                    itemNew.splcats = state.restaurant.specialCategoryAll.filter(catItems => catItems.items.indexOf(item_id) !== -1).map(catItems => catItems.cat_id)
                    splcategory.items.push(itemNew);
                    console.log(itemNew.splCats, state.restaurant.specialCategoryAll, "splCatssplCats");
                })
            }
            if (category.child_cat) {
                category.child_cat.forEach(childCat => {
                    childCat.items.forEach(item => {
                        const itemNew = { ...item };
                        const item_id = item.item_id;
                        itemNew.categoryNames = category.category_name + ' , ' + childCat.category_name;
                        itemNew.splcats = state.restaurant.specialCategoryAll.filter(catItems => catItems.items.indexOf(item_id) !== -1).map(catItems => catItems.cat_id)
                        console.log(itemNew.splCats, state.restaurant.specialCategoryAll, "splCatssplCats");
                        splcategory.items.push(itemNew);
                    })
                })
            }
        })
        if (splcategory.items.length == 0) {
            splcategory = {};
        }
        dispatch({
            type: SPL_CAT,
            payload: splcategory
        })
    }


}







String.prototype.isEqual = function (search) {
    if (this.toLowerCase().includes(search.toLowerCase())) {
        console.log(this.toLowerCase(), search.toLowerCase());
    }
    return this.toLowerCase().includes(search.toLowerCase());
}




function filterItems(category, search) {
    return category && category.items && category.items.filter(item => item.item_name.isEqual(search));

}

function filterCategories(category, search) {
    return category && category.items && category.items.some(item => item.item_name.isEqual(search));

}


function filterItemsAll(original_menu, catFunc, itemFunc, search = "") {

    let newMenu = original_menu.filter(category => {
        let isValid = false;
        if (catFunc(category, search)) {
            return true;
        }
        if (category.child_cat) {
            category.child_cat.forEach(childCat => {
                if (catFunc(childCat, search)) {
                    isValid = true;
                }
            })
        }
        return isValid;
    });

    console.log(newMenu, "only menu");

    newMenu = newMenu.map(category => {
        const newCategory = { ...category };
        if (newCategory.child_cat) {
            newCategory.child_cat = newCategory.child_cat.filter(childCat => {
                const newChildCat = { ...childCat };
                return catFunc(newChildCat, search);
            });
        }
        return newCategory;
    });


    newMenu = newMenu.map(category => {
        const newCategory = { ...category };
        const items = itemFunc(newCategory, search);
        if (items) {
            newCategory.items = items;
        } else {
            newCategory.items = [];
        }

        if (newCategory.child_cat) {
            newCategory.child_cat = newCategory.child_cat.map(ChildCat => {
                const newChildCat = { ...ChildCat };
                const itemsChildCat = itemFunc(newChildCat, search);
                console.log(newChildCat.items, search, itemsChildCat, "itemssuccesschildcat");
                if (itemsChildCat) {
                    console.log(items, "itemssuccesschildca1t");
                    newChildCat.items = itemsChildCat;
                } else {
                    newChildCat.items = [];
                }
                return newChildCat;
            })
        }
        return newCategory;
    })
    return newMenu;

}


export const searchItems = (search) => (dispatch, getState) => {
    let { original_menu } = getState().restaurant;
    if (!search) {
        const data = {};
        data.new_menu = getState().restaurant.original_menu;
        data.searchString = "";
        dispatch({
            type: SEARCH_MENU,
            payload: data
        })
        return;
    }

    let newMenu = original_menu.filter(category => {
        let isValid = false;
        if (filterCategories(category, search)) {
            return true;
        }
        if (category.child_cat) {
            category.child_cat.forEach(childCat => {
                if (filterCategories(childCat, search)) {
                    isValid = true;
                }
            })
        }
        return isValid;
    });

    console.log(newMenu, "only menu");

    newMenu = newMenu.map(category => {
        const newCategory = { ...category };
        if (newCategory.child_cat) {
            newCategory.child_cat = newCategory.child_cat.filter(childCat => {
                const newChildCat = { ...childCat };
                return filterCategories(newChildCat, search);
            });
        }
        return newCategory;
    });


    newMenu = newMenu.map(category => {
        const newCategory = { ...category };
        const items = filterItems(newCategory, search);
        if (items) {
            newCategory.items = items;
        } else {
            newCategory.items = [];
        }

        if (newCategory.child_cat) {
            newCategory.child_cat = newCategory.child_cat.map(ChildCat => {
                const newChildCat = { ...ChildCat };
                const itemsChildCat = filterItems(newChildCat, search);
                console.log(newChildCat.items, search, itemsChildCat, "itemssuccesschildcat");
                if (itemsChildCat) {
                    console.log(items, "itemssuccesschildca1t");
                    newChildCat.items = itemsChildCat;
                } else {
                    newChildCat.items = [];
                }
                return newChildCat;
            })
        }
        return newCategory;
    })


    console.log(newMenu, "newMenu", search);
    const data = {};
    data.new_menu = newMenu;
    data.searchString = search;
    dispatch({
        type: SEARCH_MENU,
        payload: data
    })
}


export const filter = (tag) => (dispatch, getState) => {
    let { original_menu } = getState().restaurant;
    if (!tag) {
        const data = {};
        data.new_menu = original_menu;
        data.searchString = "";
        dispatch({
            type: FILTER_ITEMS,
            payload: data
        })
        return;
    }

    let original_menu_new = _.cloneDeep(original_menu); // [...original_menu];



    const newMenu = original_menu_new.filter(category => {
        console.log(category.category_name);
        console.log(category.items.map((item) => { return [item.dish_new, item.item_name] }));
        if (category.items.some(item => item.dish_new.filter(value => tag.includes(value)).length > 0)) {
            return true;
        }
        if (category.child_cat) {
            return category.child_cat.some(childCat => {
                console.log(category.category_name, childCat.category_name);
                console.log(childCat.items.map((item) => { return [item.dish_new, item.item_name] }));
                return childCat.items.some(item => item.dish_new.filter(value => tag.includes(value)).length > 0)
            })
        }
    }).map(category => {
        console.log(category.category_name);
        let newCategory = _.clone(category);
        newCategory.items = _.clone(category.items);
        newCategory.items = newCategory.items.filter(item => {
            return item.dish_new.filter(value => tag.includes(value)).length > 0
        });
        if (newCategory.child_cat) {
            let mainChildCat = _.clone(newCategory.child_cat); // [...newCategory.child_cat];
            newCategory.child_cat = mainChildCat.filter(childCat => {
                return childCat.items.some(item => item.dish_new.filter(value => tag.includes(value)).length > 0)
            });
            newCategory.child_cat.forEach(element => {

                element.items = element.items.filter(item => {
                    return item.dish_new.filter(value => tag.includes(value)).length > 0
                })
            });
        }
        return newCategory;
    })
    console.log(newMenu, tag, original_menu);
    const data = {};
    data.new_menu = newMenu;
    data.searchString = tag;
    dispatch({
        type: FILTER_ITEMS,
        payload: data
    })
}